import React from 'react';
import { Button } from '@roger/ui-components';

interface MedicationsErrorStateProps {
  error: string;
  onRetry: () => void;
}

const MedicationsErrorState: React.FC<MedicationsErrorStateProps> = ({
  error,
  onRetry,
}) => {
  return (
    <div className='text-center py-8 text-destructive'>
      <p>{error}</p>
      <Button variant='outline' size='sm' className='mt-2' onClick={onRetry}>
        Retry
      </Button>
    </div>
  );
};

export default MedicationsErrorState;
